
<div>
  <slot name="nav">
    <main-nav />
  </slot>

  <slot></slot>
</div>
